// import { initialize } from '@lyceumgames/venture';
import story from './story';
import { initialize } from './platform';

initialize({
  story,
  rootId: 'react-root'
});
